import Gradient from "javascript-color-gradient";

export function getGradient(color: string, qtd: number) {
  const colorGradient = new Gradient();

  colorGradient.setMidpoint(Number(qtd));

  const colorStart = '#' + color.replace(/^#/, '').replace(/../g, color => ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + -50)).toString(16)).substr(-2));

  colorGradient.setGradient(colorStart, color);

  return colorGradient.getArray()
}
